import getActiveInputType from "./getActiveInputType";
import { ENGINE_TYPES, NODE_CHANNEL_STATE, INPUT_TYPES } from "./constants";
import store from "../../store";
import { selectors as NODE_LIVE_STATISTIC_SELECTORS } from "../../ducks/nodeLiveStats";

/** Bitrate: negatives empty/icon/playout; finite mbps; LOADING last on ascend (spin / URL metric pending). */
const SORT_BITRATE_NOT_STARTED = -500;
const SORT_BITRATE_NON_URL = -300;
const SORT_BITRATE_PLAYOUT = -100;
const SORT_BITRATE_LOADING = -10;

export const getBitrateColumnSortParts = (record) => {
  const status = record?.status;
  const channelStatus = status?.channelStatusText;
  const channelId = status?.channelId;
  const playingSource = status?.playingSource;
  const config = record?.config;

  if (config?.type === ENGINE_TYPES.PLAYOUT) {
    return { primary: SORT_BITRATE_PLAYOUT, secondary: record?.config?.name ?? "" };
  }

  if (channelStatus !== NODE_CHANNEL_STATE.STARTED) {
    return { primary: SORT_BITRATE_NOT_STARTED, secondary: record?.config?.name ?? "" };
  }

  const inputType = getActiveInputType({ playingSource, config });

  if (!inputType) {
    return { primary: SORT_BITRATE_LOADING, secondary: record?.config?.name ?? "" };
  }

  if (inputType !== INPUT_TYPES.inputUrl.value) {
    return { primary: SORT_BITRATE_NON_URL, secondary: record?.config?.name ?? "" };
  }

  if (playingSource == null || playingSource === "") {
    return { primary: SORT_BITRATE_LOADING, secondary: record?.config?.name ?? "" };
  }

  const raw = NODE_LIVE_STATISTIC_SELECTORS.getLastBitrateV5({
    state: store.getState(),
    channelId,
    playingSource: playingSource ?? "",
  });
  const n = raw == null || raw === "" ? NaN : Number(raw);

  if (!Number.isFinite(n)) {
    return { primary: SORT_BITRATE_LOADING, secondary: record?.config?.name ?? "" };
  }

  return { primary: n, secondary: record?.config?.name ?? "" };
};

export const compareBitrateColumn = (a, b) => {
  const pa = getBitrateColumnSortParts(a);
  const pb = getBitrateColumnSortParts(b);
  const byPrimary = pa.primary - pb.primary;

  if (byPrimary !== 0) {
    return byPrimary;
  }

  return pa.secondary.localeCompare(pb.secondary, undefined, { sensitivity: "base", numeric: true });
};
